import React, { useMemo } from 'react';
import cn from 'classnames';
import { ContactHeader } from '@repo/components/headers';
import { Section, SectionTitle } from '@repo/components/containers';
import Note from '@repo/utils/models/Note';
import sharedStyles from '../WelcomeGuide.module.scss';
import styles from './Notes.module.scss';
import Contact from '@repo/utils/models/Contact';
import { NoteView } from '@repo/components/notes';

const personFirstName = 'Christine';
const person1 = `${personFirstName} Diaz`;
const person2 = 'Yuri Humphries';

export default function Notes({ onClick, contacts }) {
  const notes = useMemo(() => {
    let username = personFirstName;
    let mention = `00:${person2}`;

    if (contacts.length > 2) {
      username = contacts[0].firstName || contacts[0].displayName;
      mention = String(contacts[1].id) + ':' + contacts[1].displayName;
    }

    mention = `[contact:${mention}]`;

    return [
      new Note({
        content: `${username} and I just finished reading Life of Pi together with ${mention}. We all agreed we prefer the story with animals`,
      }),
      new Note({
        content:
          'We emailed back and forth about their new job, they seem really happy and relaxed even though the job is very demanding.',
        updated: (Date.now() - 1000 * 60 * 60 * 47.76) / 1000,
      }),
    ];
  }, [contacts]);

  return (
    <div className={cn(sharedStyles.page, sharedStyles.numberedPage)} onClick={onClick}>
      <div className={styles.container}>
        <div className={styles.notesSection}>
          <ContactHeader
            className={styles.header}
            contact={contacts[0] || new Contact({ displayName: person1 })}
          />
          <Section>
            <SectionTitle className={styles.sectionTitle} underline>
              Notes
            </SectionTitle>
            {notes.map((note) => (
              <NoteView key={note.id} note={note} selected={false} />
            ))}
          </Section>
        </div>
      </div>
      <div className={cn(sharedStyles.pageContent, sharedStyles.right)}>
        <h2>Note Taking</h2>
        <p>
          Taking good notes allow us to deepen our existing relationships over time by remembering
          all the thoughtful details we sometimes forget.
        </p>
        <p>
          From birthdays to passions—we’ve made creating notes effortless, private and searchable
          for everyone you care about.
        </p>
      </div>
      <div className={sharedStyles.pageNumber}>02 — Notes</div>
    </div>
  );
}
